import type { FC, ReactNode } from "react";
import { Icon } from "../Icon/Icon";
import { IconNames } from "../Icon/svg";
import classes from "./Sharing.module.scss";

export interface SharingProps {
	name: IconNames;
	title: string;
	children: ReactNode;
}

export interface SharingComponent extends FC<SharingProps> {}

export const Sharing: SharingComponent = ({ name, title, children }) => {
	return (
		<div className={classes.wrapper}>
			<div className={classes.content}>
				<Icon name={name} />
				<div className={classes.info}>
					<h6 className={classes.title}>{title}</h6>
					<span className={classes.text}>{children}</span>
				</div>
			</div>
		</div>
	);
};
